import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from '../icon';

function FieldStatus({
  text = 'Invalid input',
  glyph = 'alert-circle',
  className = null,
  isStatic = false,
  ...otherProps
}) {
  const classes = classNames('ws-field-status', className, { 'ws-field-status--static': isStatic });
  const iconSize = 24;

  return (
    <div {...otherProps} className={classes}>
      <Icon glyph={glyph} size={iconSize} />
      {text}
    </div>
  );
}

FieldStatus.propTypes = {
  text: PropTypes.string,
  glyph: PropTypes.string,
  className: PropTypes.string,
  isStatic: PropTypes.bool,
};

export default FieldStatus;
